// Contractor service catalogue — mirrors constants/services.js in
// beleef-services-frontend and ALL_SERVICES in the backend Contractor model.
export const MEDIA_SERVICES = [
  { value: "photo", label: "Photo" },
  { value: "video", label: "Video" },
  { value: "floorplan", label: "Floorplan" },
  { value: "floorplanRedraw", label: "Floorplan Redraw" },
];

export const EXCLUSIVE_SERVICES = [
  { value: "edit", label: "Editing" },
  { value: "print", label: "Printing" },
  { value: "auction", label: "Auction" },
  { value: "buildingPest", label: "Building & Pest" },
  { value: "strata", label: "Strata Report" },
  { value: "styling", label: "Styling" },
  { value: "gifting", label: "Gifting" },
];

export const ALL_SERVICES = [...MEDIA_SERVICES, ...EXCLUSIVE_SERVICES];

export const getServiceLabel = (value) =>
  ALL_SERVICES.find((s) => s.value === value)?.label || value;
